import React, { useState } from "react";
import styles from "./PlaydateInviteRecipientView.module.css";
import PlaydateInviteBaseView from "./PlaydateInviteBaseView";
import TextAreaInput from "../../input/TextAreaInput";
import ActionButton from "../../button/ActionButton";
import UnderlineButton from "../../button/UnderlineButton";

type PlaydateInviteOrganizerCancellationViewProps = {
    onBack: () => void;
    onSubmitCancel: (message: string) => void;
    baseZIndex?: number;
    loading?: boolean;
};

const PlaydateInviteOrganizerCancellationView: React.FC<PlaydateInviteOrganizerCancellationViewProps> = ({
    onBack,
    onSubmitCancel,
    baseZIndex,
    loading,
}) => {
    const [cancelMessage, setCancelMessage] = useState<string>("");

    return (
        <PlaydateInviteBaseView
            baseZIndex={baseZIndex}
            onBack={onBack}
            title="Playdate Details"
            infoText="Are you sure you’d like to cancel the invite? Please let the guests know why you can’t make it."
            topIcon="alert"
            useSectionDivider={false}
        >
            <TextAreaInput
                message={cancelMessage}
                placeholder="(optional)"
                setMessage={setCancelMessage}
                className={styles.cancellationMessageTextArea}
            />
            <div className={styles.buttonBuffer} />
            <div className={styles.buttonContainer}>
                <ActionButton
                    onClick={() => onSubmitCancel(cancelMessage)}
                    hasLoadingSignal={loading}
                    className={styles.cancellationPrimaryButton}
                    isLongText={true}
                >
                    Send Message and Cancel Invite
                </ActionButton>
                <UnderlineButton onClick={onBack}>
                    Back to Invite Details
                </UnderlineButton>
            </div>
        </PlaydateInviteBaseView>
    );
};

export default PlaydateInviteOrganizerCancellationView;
